import { useEffect } from 'react'
import { HeaderHLPure } from '../../pures'
import  { Container, Grid, Paper } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import IFrame from '../../pures/dashboard/iframe'

const AssistantView = (props) => {
    // #region variables
    const { chatbotUrl, handleLoadChat, botConfig, showIframe } = props
    const { t } = useTranslation('clients-dashboard', { keyPrefix: 'assistantScreen' })
    // #endregion variables

    // #region effects
    /**
     * @description effect to listen messages from iframe
     * @author Antonio Vazquez
     * @createdDate 28-11-25
     */
    useEffect(() => {
        window.addEventListener("message", (event) => {
            if (event.data.action === "rootResult") {
                console.log("¿Tiene elementos?", event.data.hasElements);
            }
        })
    }, [])

    /**
     * @description effect to load chat when botConfig change
     * @author Antonio Vazquez
     * @createdDate 28-11-25
     */
    useEffect(() => {
        try {
            if (botConfig && botConfig?.id) {
                handleLoadChat()
            }
        } catch (e) {
            console.error(e)
        }
    }, [botConfig])
    // #endregion effects

    return (
        <div className='fullViewHeight'>
            <Container  className='fullViewHeight' style={{ paddingTop: 16 }}>
                <Grid container spacing={3} className='fullViewHeight'>
                    <Grid item xs={12}>
                        <HeaderHLPure title={t('title')} />
                    </Grid>
                    <Grid item xs={12} lg={12} className='iframeContainer'>
                        <Paper className='iframePaperContainer'>
                            <div className='iframeContainer'>
                                {
                                    (botConfig?.id && showIframe) &&
                                    <IFrame height={'100%'} width={'100%'} url={chatbotUrl} />
                                }
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export { AssistantView as default }